import React from 'react';
import styles from './Services.module.css';
import { ReactComponent as Wash } from './../../../Svg/wash.svg';

function Services({ isBook }) {
	return (
		<section
			id="services"
			className={!isBook ? styles.services : styles.services__without__bg}>
			{' '}
			<div className="block__title">
				<div className="title__line"></div>Наши услуги
				<div className="title__line"></div>
			</div>
			<div className={styles.services__list}>
				<div className={styles.list__item}>
					<Wash />
					<span>
						Стирка и утюжка: брюки, джинсы, платье, пуловер, спортивный костюм —
						<span className={styles.bold__text}> 200 ₽</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<Wash />
					<span>
						Стирка и утюжка: шорты, бриджи, юбка, рубашка, футболка, личное полотенце —
						<span className={styles.bold__text}> 100 ₽</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none">
						<path
							d="M18 0.00146484H5C2.243 0.00146484 0 2.24435 0 5.00121V15.0007C0 17.7575 2.243 20.0004 5 20.0004H17C18.654 20.0004 20 18.6545 20 17.0006C20 15.3467 18.654 14.0007 17 14.0007H4V16.0006H17C17.552 16.0006 18 16.4486 18 17.0006C18 17.5526 17.552 18.0005 17 18.0005H5C3.346 18.0005 2 16.6546 2 15.0007C2 13.3468 3.346 12.0008 5 12.0008H18C19.103 12.0008 20 11.1039 20 10.0009V2.00136C20 0.898418 19.103 0.00146484 18 0.00146484ZM18 10.0009H5C3.875 10.0009 2.836 10.3739 2 11.0029V5.00121C2 3.34729 3.346 2.00136 5 2.00136H18V10.0009Z"
							fill="#956446"
						/>
					</svg>
					<span>
						Дополнительный комплект белья —
						<span className={styles.bold__text}> 200 ₽</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="25"
						viewBox="0 0 25 25"
						fill="none">
						<path
							d="M7.2915 13.0212C7.90957 13.0212 8.51376 12.838 9.02766 12.4946C9.54156 12.1513 9.9421 11.6632 10.1786 11.0923C10.4152 10.5213 10.477 9.89302 10.3565 9.28688C10.2359 8.68074 9.93825 8.12397 9.50121 7.68697C9.06417 7.24997 8.50735 6.95236 7.90116 6.8318C7.29497 6.71123 6.66664 6.77311 6.09562 7.00961C5.5246 7.24611 5.03654 7.64662 4.69316 8.16048C4.34978 8.67434 4.1665 9.27847 4.1665 9.89649C4.1665 10.7252 4.49574 11.52 5.0818 12.106C5.66785 12.692 6.4627 13.0212 7.2915 13.0212ZM7.2915 8.85491C7.49753 8.85491 7.69892 8.916 7.87022 9.03045C8.04152 9.1449 8.17504 9.30757 8.25388 9.49789C8.33272 9.68822 8.35335 9.89764 8.31316 10.0997C8.27296 10.3017 8.17375 10.4873 8.02807 10.633C7.88239 10.7787 7.69679 10.8779 7.49472 10.9181C7.29266 10.9582 7.08322 10.9376 6.89288 10.8588C6.70254 10.7799 6.53985 10.6464 6.42539 10.4752C6.31093 10.3039 6.24984 10.1025 6.24984 9.89649C6.24984 9.62024 6.35958 9.35532 6.55493 9.15998C6.75029 8.96465 7.01524 8.85491 7.2915 8.85491ZM20.8332 6.77175H12.4998C12.2236 6.77175 11.9586 6.88149 11.7633 7.07683C11.5679 7.27216 11.4582 7.53709 11.4582 7.81333V14.0628H3.12484V5.73018C3.12484 5.45393 3.01509 5.189 2.81974 4.99367C2.62439 4.79834 2.35944 4.6886 2.08317 4.6886C1.8069 4.6886 1.54195 4.79834 1.3466 4.99367C1.15125 5.189 1.0415 5.45393 1.0415 5.73018V19.2707C1.0415 19.5469 1.15125 19.8119 1.3466 20.0072C1.54195 20.2025 1.8069 20.3123 2.08317 20.3123C2.35944 20.3123 2.62439 20.2025 2.81974 20.0072C3.01509 19.8119 3.12484 19.5469 3.12484 19.2707V16.146H21.8748V19.2707C21.8748 19.5469 21.9846 19.8119 22.1799 20.0072C22.3753 20.2025 22.6402 20.3123 22.9165 20.3123C23.1928 20.3123 23.4577 20.2025 23.6531 20.0072C23.8484 19.8119 23.9582 19.5469 23.9582 19.2707V9.89649C23.9582 9.06776 23.6289 8.27297 23.0429 7.68697C22.4568 7.10097 21.662 6.77175 20.8332 6.77175ZM21.8748 14.0628H13.5415V8.85491H20.8332C21.1094 8.85491 21.3744 8.96465 21.5697 9.15998C21.7651 9.35532 21.8748 9.62024 21.8748 9.89649V14.0628Z"
							fill="#956446"
						/>
					</svg>
					<span>
						Дополнительное место —
						<span className={styles.bold__text}> 300 ₽</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="23"
						height="24"
						viewBox="0 0 23 24"
						fill="none">
						<path
							d="M21.9545 13.5924C22.2318 13.5924 22.4977 13.4822 22.6938 13.2862C22.8899 13.0901 23 12.8242 23 12.5469V9.41055C23 8.85601 22.7797 8.32418 22.3876 7.93206C21.9955 7.53994 21.4636 7.31965 20.9091 7.31965H18.7136C18.4709 6.13976 17.8289 5.0796 16.8958 4.31785C15.9626 3.5561 14.7954 3.13935 13.5908 3.13783H12.5454V2.09237H13.5908C13.8681 2.09237 14.134 1.98223 14.3301 1.78617C14.5261 1.59011 14.6363 1.32419 14.6363 1.04692C14.6363 0.769648 14.5261 0.503732 14.3301 0.307671C14.134 0.111611 13.8681 0.00146484 13.5908 0.00146484H9.40896C9.13169 0.00146484 8.86577 0.111611 8.66971 0.307671C8.47364 0.503732 8.36349 0.769648 8.36349 1.04692C8.36349 1.32419 8.47364 1.59011 8.66971 1.78617C8.86577 1.98223 9.13169 2.09237 9.40896 2.09237H10.4544V3.13783H9.40896C8.20437 3.13935 7.03713 3.5561 6.10398 4.31785C5.17083 5.0796 4.52883 6.13976 4.28618 7.31965H1.04524C0.838501 7.31969 0.636415 7.38103 0.46453 7.49591C0.292645 7.61079 0.15868 7.77405 0.0795693 7.96505C0.000458908 8.15606 -0.0202445 8.36623 0.0200766 8.569C0.0603976 8.77177 0.159933 8.95803 0.306098 9.10424L4.18164 12.9797V21.956C4.18164 22.2333 4.29178 22.4992 4.48785 22.6953C4.68391 22.8913 4.94983 23.0015 5.2271 23.0015H17.7727C18.05 23.0015 18.3159 22.8913 18.5119 22.6953C18.708 22.4992 18.8181 22.2333 18.8181 21.956V9.41055H20.9091V12.5469C20.9091 12.8242 21.0192 13.0901 21.2153 13.2862C21.4113 13.4822 21.6773 13.5924 21.9545 13.5924ZM9.40896 5.22874H13.5908C14.2393 5.22953 14.8716 5.4309 15.4012 5.80525C15.9307 6.17959 16.3314 6.70857 16.5484 7.31965H6.45134C6.66836 6.70857 7.06911 6.17959 7.59862 5.80525C8.12813 5.4309 8.76049 5.22953 9.40896 5.22874ZM16.7272 20.9106H6.27257V15.7617C6.94989 15.5269 7.66907 15.4374 8.38328 15.499C9.09749 15.5606 9.79072 15.7719 10.4178 16.1192C12.3873 17.0375 14.5608 17.4308 16.7272 17.2609V20.9106ZM16.7272 15.1438C14.8173 15.3417 12.89 15.0028 11.1622 14.1653C9.65689 13.3833 7.91649 13.1823 6.27257 13.6007V12.5469C6.27251 12.2697 6.16232 12.0038 5.96624 11.8078L3.56899 9.41055H16.7272V15.1438Z"
							fill="#956446"
						/>
					</svg>
					<span>
						Чайник по запросу —
						<span className={styles.bold__text}> бесплатно</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="20"
						viewBox="0 0 25 20"
						fill="none">
						<path
							d="M21.7 1.00146H3.3C2.02974 1.00146 1 1.94958 1 3.11914V14.7664C1 15.9359 2.02974 16.884 3.3 16.884H21.7C22.9703 16.884 24 15.9359 24 14.7664V3.11914C24 1.94958 22.9703 1.00146 21.7 1.00146Z"
							stroke="#956446"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M13.6516 5.23596H6.75156C6.11644 5.23596 5.60156 5.71002 5.60156 6.2948V11.589C5.60156 12.1738 6.11644 12.6478 6.75156 12.6478H13.6516C14.2867 12.6478 14.8016 12.1738 14.8016 11.589V6.2948C14.8016 5.71002 14.2867 5.23596 13.6516 5.23596Z"
							stroke="#956446"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M19.3984 5.23596V12.6478"
							stroke="#956446"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M5.60156 16.8833V19.001"
							stroke="#956446"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M19.3984 16.8833V19.001"
							stroke="#956446"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					<span>
						Микроволновка —
						<span className={styles.bold__text}> бесплатно</span>
					</span>
				</div>
				<div className={styles.list__item}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="25"
						viewBox="0 0 25 25"
						fill="none">
						<path
							d="M18.8332 7.29286C18.6963 7.28147 18.5585 7.29726 18.4278 7.33932C18.297 7.38139 18.1759 7.4489 18.0713 7.53797C17.9667 7.62703 17.8808 7.7359 17.8185 7.8583C17.7562 7.9807 17.7187 8.11421 17.7082 8.25116L17.3436 12.9906C16.8619 12.8415 16.4299 12.5642 16.0936 12.1885C15.9958 12.0777 15.8756 11.9889 15.7409 11.9281C15.6062 11.8673 15.4601 11.8359 15.3123 11.8359C15.1646 11.8359 15.0185 11.8673 14.8838 11.9281C14.7491 11.9889 14.6288 12.0777 14.5311 12.1885C14.2726 12.4695 13.9586 12.6937 13.6089 12.8471C13.2593 13.0005 12.8816 13.0797 12.4998 13.0797C12.118 13.0797 11.7404 13.0005 11.3908 12.8471C11.0411 12.6937 10.7271 12.4695 10.4686 12.1885C10.3708 12.0777 10.2506 11.9889 10.1159 11.9281C9.98123 11.8673 9.83513 11.8359 9.68735 11.8359C9.53956 11.8359 9.39346 11.8673 9.25876 11.9281C9.12407 11.9889 9.00385 12.0777 8.9061 12.1885C8.56882 12.563 8.1371 12.8401 7.6561 12.9906L7.29151 8.25116C7.281 8.11421 7.2435 7.9807 7.18118 7.8583C7.11886 7.7359 7.03295 7.62703 6.92839 7.53797C6.82383 7.4489 6.70268 7.38139 6.57193 7.33932C6.44118 7.29726 6.30339 7.28147 6.16651 7.29286C6.02956 7.30337 5.89604 7.34087 5.77364 7.40319C5.65123 7.4655 5.54236 7.55141 5.4533 7.65597C5.36423 7.76053 5.29671 7.88167 5.25465 8.01241C5.21258 8.14316 5.19679 8.28094 5.20818 8.41782L6.10401 20.032C6.16449 20.8186 6.52025 21.5532 7.09987 22.0883C7.6795 22.6235 8.4401 22.9197 9.22901 22.9173H15.7915C16.5804 22.9197 17.341 22.6235 17.9207 22.0883C18.5003 21.5532 18.856 20.8186 18.9165 20.032L19.7915 8.41782C19.8029 8.28094 19.7871 8.14316 19.745 8.01241C19.703 7.88167 19.6355 7.76053 19.5464 7.65597C19.4573 7.55141 19.3485 7.4655 19.2261 7.40319C19.1037 7.34087 18.9701 7.30337 18.8332 7.29286ZM16.8123 19.8758C16.7914 20.1373 16.6724 20.3813 16.4793 20.559C16.2862 20.7367 16.0331 20.8349 15.7707 20.8341H9.2186C8.95618 20.8349 8.70311 20.7367 8.50999 20.559C8.31687 20.3813 8.19792 20.1373 8.17693 19.8758L7.81235 15.1051C8.4877 14.9639 9.12626 14.6837 9.68735 14.2822C10.5089 14.8662 11.4919 15.18 12.4998 15.18C13.5078 15.18 14.4908 14.8662 15.3123 14.2822C15.8734 14.6837 16.512 14.9639 17.1873 15.1051L16.8123 19.8758ZM12.4998 10.4178C13.3969 10.415 14.2564 10.0575 14.8907 9.42319C15.525 8.78891 15.8825 7.92944 15.8853 7.03245C15.8853 4.16796 13.1978 2.33469 13.0832 2.26178C12.9109 2.14535 12.7078 2.08313 12.4998 2.08313C12.2919 2.08313 12.0888 2.14535 11.9165 2.26178C11.8019 2.34511 9.11443 4.16796 9.11443 7.03245C9.11718 7.92944 9.47474 8.78891 10.109 9.42319C10.7433 10.0575 11.6028 10.415 12.4998 10.4178ZM12.4998 4.48045C13.2536 5.12598 13.7217 6.0433 13.8019 7.03245C13.8019 7.37777 13.6647 7.70895 13.4206 7.95313C13.1764 8.19731 12.8452 8.33449 12.4998 8.33449C12.1545 8.33449 11.8233 8.19731 11.5791 7.95313C11.3349 7.70895 11.1978 7.37777 11.1978 7.03245C11.2835 6.04486 11.7505 5.12949 12.4998 4.48045Z"
							fill="#956446"
						/>
					</svg>
					<span>
						Кулер на каждом этаже —
						<span className={styles.bold__text}> бесплатно</span>
					</span>
				</div>
			</div>
		</section>
	);
}

export default Services;
